import { Radio } from 'antd'
import styled from '@emotion/styled'
import { css } from '@emotion/react'

export default styled(Radio.Group)`
  .ant-radio-inner {
    box-sizing: border-box;
    height: 16px;
    width: 16px;
    border: 1px solid #cfcfcf;
    border-radius: 50%;
    background-color: #ffffff;
  }
  .ant-radio {
    vertical-align: middle;
  }
  span.ant-radio + * {
    display: inline-block;
    vertical-align: middle;
  }
  .ant-radio-wrapper {
    vertical-align: middle;
    &:hover,
    &:focus {
      .ant-radio .ant-radio-inner {
        border-color: #5d5d5d; /* #ff6b00; orange */
      }
    }
  }
  .ant-radio-checked {
    &::after {
      animation: none;
      border-color: #ff6b00;
    }
  }
  .ant-radio-checked > .ant-radio-inner {
    border-color: #ff6b00;
    transition: none;
    &::after {
      position: absolute;
      left: 2px;
      top: 2px;
      display: block;
      width: 10px;
      height: 10px;
      border-radius: 50%;
      background-color: #ff6b00;
      -webkit-transition: none;
      transition: none;
    }
  }

  ${({ custom }) => {
    if (custom === 'inline') {
      return css`
        && {
          flex-direction: row;
        }
      `
    }
  }}
`
